// extracted by mini-css-extract-plugin
export default {"basic-input":"BasicInput_basic-input__tw5a6","input-label":"BasicInput_input-label__2395Z","error":"BasicInput_error__GyFs2"};